












































import { Component, Vue } from "vue-property-decorator";
import AuthorizationModule from "@/modules/Authorization/store";
import NotificationModule from "@/modules/Notification/store";

@Component({
  components: {}
})
export default class AuthorizationPage extends Vue {
  id = "";
  requiredLength = 24;

  mounted() {
    const input = this.$el.querySelector("#id");
    (input as HTMLElement).focus();
  }

  fillWithTestData() {
    this.id = "5f8475902b0be670555f1bb3";
  }

  get setClassStatus() {
    return this.id?.length < this.requiredLength ? "error" : "successfully";
  }

  get validationInput() {
    return this.id?.length !== this.requiredLength;
  }

  get getLengthInput() {
    return this.id?.length;
  }

  submitHandler() {
    AuthorizationModule.authorizationAction(this.id)
      .then((resp) => {
        if (resp === "ok") {
          NotificationModule.setNotificationOptions({
            message: "Поздравляю, вы успешно авторизованы!",
            type: "success"
          });
          NotificationModule.toggleShowNotification(true);
          setTimeout(() => {
            NotificationModule.toggleShowNotification(false);
          }, 3000);
          this.$router.push("/analytics");
        }
      })
      .catch(() => {
        NotificationModule.setNotificationOptions({
          message: "К сожалению, не удалось войти!",
          type: "error"
        });
        NotificationModule.toggleShowNotification(true);
        setTimeout(() => {
          NotificationModule.toggleShowNotification(false);
        }, 3000);
        console.error("Ошибка запроса");
      });
  }
  setTextWithEnding(number: number, one: string, two: string, five: string) {
    let n = Math.abs(number);
    n %= 100;
    if (n >= 5 && n <= 20) {
      return five;
    }
    n %= 10;
    if (n === 1) {
      return one;
    }
    if (n >= 2 && n <= 4) {
      return two;
    }
    return five;
  }
}
